type CreateLazyLoadGroupOptions = {
  rootMargin?: string;
  selector?: string;
};

/**
 * Ensures all lazy loaded images inside the given node are loaded when the node is within the rootMargin (defaults to
 * 1000px) distance of the viewport.
 */
export const createLazyLoadGroup = (node: Element, options?: CreateLazyLoadGroupOptions) => {
  const { rootMargin = '1000px', selector = 'img[loading="lazy"]' } = options ?? {};

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        return;
      }

      const images = node.querySelectorAll(selector);
      for (const img of images) {
        img.removeAttribute('loading');
      }
    },
    {
      rootMargin,
    }
  );

  observer.observe(node);

  return {
    destroy() {
      observer.disconnect();
    },
  };
};
